import Axios from "axios";
export default class cart {
get_count ( store ) {

     let hostname = window.location.hostname;
    let params = new URLSearchParams();
    params.append('action', 'CART_COUNT');
    let url =     "https://"+hostname+"/wp-admin/admin-ajax.php";
    if (hostname.includes('localhost')) {
        url = "http://localhost/vistosiwoocommerce/wp-admin/admin-ajax.php";
  
      }
    Axios.post(
        url,
      params
    )
      .then( (response) => {
        try {
            store.cart.count = response.data;
        } catch (error) {
         this.errors = error;
        }
      })
      .catch(function (error) {
        this.errors = error;
      });

}

      
}
